import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Copyright,
} from "lucide-react";
import { useState } from "react";
import InfoModal from "./InfoModal";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { ref: footerRef, isIntersecting: isVisible } =
    useIntersectionObserver();

  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showSecurity, setShowSecurity] = useState(false);
  const [showAccessibility, setShowAccessibility] = useState(false);

  const privacyPolicyContent = (
    <div className="space-y-4">
      <p>
        Kebijakan Privasi PT Neuronworks Indonesia ("kami") menjelaskan
        bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi
        pribadi Anda saat Anda menggunakan layanan Perisalah.
      </p>

      <h3 className="text-xl font-semibold mt-4">
        Informasi yang Kami Kumpulkan
      </h3>
      <p>Kami mengumpulkan informasi berikut:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>Informasi akun (nama, email, perusahaan)</li>
        <li>Data penggunaan layanan</li>
        <li>Data yang Anda unggah untuk dianalisis</li>
        <li>Informasi perangkat dan browser</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">
        Bagaimana Kami Menggunakan Informasi Anda
      </h3>
      <p>Kami menggunakan informasi untuk:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>Menyediakan dan meningkatkan layanan kami</li>
        <li>Menganalisis penggunaan layanan</li>
        <li>Berkomunikasi dengan Anda tentang akun dan layanan</li>
        <li>Melindungi keamanan layanan kami</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Keamanan Data</h3>
      <p>
        Kami menerapkan langkah-langkah keamanan teknis dan organisasi untuk
        melindungi data Anda. Data dienkripsi saat dalam penyimpanan dan
        transmisi.
      </p>

      <h3 className="text-xl font-semibold mt-4">Hak Privasi Anda</h3>
      <p>Anda memiliki hak untuk:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>Mengakses data pribadi Anda</li>
        <li>Memperbaiki data yang tidak akurat</li>
        <li>Meminta penghapusan data</li>
        <li>Membatasi pengolahan data</li>
        <li>Menarik persetujuan kapan saja</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Kontak</h3>
      <p>
        Jika Anda memiliki pertanyaan tentang kebijakan privasi kami, silakan
        hubungi kami di{" "}
        <a
          href="mailto:info@perisalah.id"
          className="text-Perisalah-blue hover:underline"
        >
          info@perisalah.id
        </a>
      </p>
    </div>
  );

  const termsContent = (
    <div className="space-y-4">
      <p>
        Dengan menggunakan layanan Perisalah, Anda menyetujui syarat dan
        ketentuan berikut:
      </p>

      <h3 className="text-xl font-semibold mt-4">Penggunaan Layanan</h3>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Anda harus berusia minimal 18 tahun untuk menggunakan layanan ini
        </li>
        <li>Anda bertanggung jawab atas kerahasiaan kredensial akun Anda</li>
        <li>
          Anda setuju untuk tidak menyalahgunakan layanan atau mencoba mengakses
          secara tidak sah
        </li>
        <li>
          Kami berhak menangguhkan atau menghentikan akses jika terjadi
          pelanggaran
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Langganan dan Pembayaran</h3>
      <ul className="list-disc pl-5 space-y-2">
        <li>Biaya berlangganan dibebankan sesuai paket yang Anda pilih</li>
        <li>
          Pembayaran tidak dapat dikembalikan kecuali ditentukan lain oleh hukum
        </li>
        <li>
          Kami dapat mengubah harga dengan pemberitahuan 30 hari sebelumnya
        </li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Konten Pengguna</h3>
      <p>
        Anda mempertahankan hak atas data yang Anda unggah. Anda memberikan kami
        lisensi untuk menampilkan, menyimpan, dan memproses data tersebut untuk
        tujuan menyediakan layanan.
      </p>

      <h3 className="text-xl font-semibold mt-4">Batasan Tanggung Jawab</h3>
      <p>
        Layanan disediakan "sebagaimana adanya" tanpa jaminan apapun. Kami tidak
        bertanggung jawab atas kerugian tidak langsung atau konsekuensial.
      </p>

      <h3 className="text-xl font-semibold mt-4">
        Perubahan pada Syarat Layanan
      </h3>
      <p>
        Kami dapat memperbarui syarat layanan dari waktu ke waktu. Kami akan
        memberi tahu Anda tentang perubahan penting melalui email atau
        pemberitahuan di aplikasi.
      </p>
    </div>
  );
  const securityContent = (
    <div className="space-y-4">
      <p>
        Di Perisalah, keamanan data Anda adalah prioritas utama kami. Berikut
        adalah langkah-langkah yang kami ambil untuk melindungi informasi Anda:
      </p>

      <h3 className="text-xl font-semibold mt-4">Enkripsi Data</h3>
      <p>
        Semua data disimpan dan ditransmisikan menggunakan enkripsi standar
        industri (AES-256 dan TLS 1.3) untuk memastikan kerahasiaan dan
        integritas.
      </p>

      <h3 className="text-xl font-semibold mt-4">Keamanan Infrastruktur</h3>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Infrastruktur cloud kami menggunakan isolasi jaringan dan perlindungan
          DDoS
        </li>
        <li>
          Pemindaian kerentanan rutin dan pengujian penetrasi oleh pihak ketiga
        </li>
        <li>Pemantauan keamanan 24/7 untuk mendeteksi dan merespons insiden</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Keamanan Akun</h3>
      <ul className="list-disc pl-5 space-y-2">
        <li>Autentikasi multi-faktor tersedia untuk semua akun</li>
        <li>Kebijakan kata sandi yang kuat</li>
        <li>Pembatasan akses berbasis peran</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">Kepatuhan</h3>
      <p>
        Kami mematuhi standar keamanan industri dan peraturan privasi data,
        termasuk praktik terbaik OWASP dan prinsip-prinsip Pribadi secara
        Desain.
      </p>

      <h3 className="text-xl font-semibold mt-4">Pelaporan Kerentanan</h3>
      <p>
        Jika Anda menemukan kerentanan keamanan di produk kami, silakan laporkan
        ke{" "}
        <a
          href="mailto:security@perisalah.id"
          className="text-Perisalah-blue hover:underline"
        >
          security@perisalah.id
        </a>
      </p>
    </div>
  );

  const accessibilityContent = (
    <div className="space-y-4">
      <p>
        Perisalah berkomitmen untuk membuat platformnya dapat diakses oleh semua
        orang, termasuk mereka yang memiliki keterbatasan. Kami berupaya
        memenuhi pedoman aksesibilitas WCAG 2.1 Level AA.
      </p>

      <h3 className="text-xl font-semibold mt-4">Fitur Aksesibilitas</h3>
      <ul className="list-disc pl-5 space-y-2">
        <li>Navigasi keyboard penuh untuk semua fungsi</li>
        <li>Kompatibilitas dengan pembaca layar</li>
        <li>Teks alternatif untuk semua gambar</li>
        <li>Kontras warna yang cukup untuk teks dan elemen antarmuka</li>
        <li>Teks yang dapat diubah ukurannya tanpa kehilangan fungsi</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4">
        Teknologi Bantuan yang Didukung
      </h3>
      <p>
        Kami menguji dan mendukung pembaca layar populer seperti NVDA, JAWS, dan
        VoiceOver. Kami juga mendukung teknologi pembesaran layar dan input
        suara.
      </p>

      <h3 className="text-xl font-semibold mt-4">Umpan Balik dan Bantuan</h3>
      <p>
        Kami terus berupaya meningkatkan aksesibilitas. Jika Anda mengalami
        hambatan dalam menggunakan layanan kami atau memiliki saran untuk
        perbaikan, silakan hubungi kami di{" "}
        <a
          href="mailto:accessibility@perisalah.id"
          className="text-Perisalah-blue hover:underline"
        >
          accessibility@perisalah.id
        </a>
      </p>

      <h3 className="text-xl font-semibold mt-4">Penilaian dan Pembaruan</h3>
      <p>
        Kami melakukan audit aksesibilitas secara berkala dan terus memperbaiki
        platform kami berdasarkan temuan dan umpan balik pengguna.
      </p>
    </div>
  );

  return (
    <footer
      id="kontak"
      className="bg-black border-t border-white/10 py-16"
      ref={footerRef}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-10">
          <div
            className={`${
              isVisible ? "animate-fade-in-left" : "opacity-0"
            } col-span-1 md:col-span-1 lg:col-span-1`}
          >
            <h3 className="text-2xl font-bold text-gradient mb-4">Perisalah</h3>
            <p className="text-gray-300 mb-6">
              Rekam rapat, transkripsi otomatis, dan konversi percakapan menjadi
              dokumen bernilai dengan bantuan teknologi AI.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://x.com/neuronworks"
                target="_blank"
                className="text-gray-400 hover:text-perisalah-blue transition-colors p-2 rounded-full hover:bg-white/5"
                aria-label="Twitter"
              >
                <Twitter size={24} />
              </a>
              <a
                href="https://www.facebook.com/neuronworks"
                target="_blank"
                className="text-gray-400 hover:text-perisalah-blue transition-colors p-2 rounded-full hover:bg-white/5"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a>
              <a
                href="https://www.instagram.com/neuronworks/"
                target="_blank"
                className="text-gray-400 hover:text-perisalah-blue transition-colors p-2 rounded-full hover:bg-white/5"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
              <a
                href="https://www.linkedin.com/company/neuronworks-indonesia/"
                target="_blank"
                className="text-gray-400 hover:text-perisalah-blue transition-colors p-2 rounded-full hover:bg-white/5"
                aria-label="LinkedIn"
              >
                <Linkedin size={24} />
              </a>
            </div>
          </div>

          <div
            className={`${
              isVisible ? "animate-fade-in-up delay-200" : "opacity-0"
            }`}
          >
            <h4 className="text-lg font-semibold mb-4 text-white">Produk</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#fitur"
                  className="text-gray-300 hover:text-perisalah-purple transition-colors"
                >
                  Fitur
                </a>
              </li>
              <li>
                <a
                  href="#harga"
                  className="text-gray-300 hover:text-perisalah-purple transition-colors"
                >
                  Harga
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`${
              isVisible ? "animate-fade-in-up delay-300" : "opacity-0"
            }`}
          >
            <h4 className="text-lg font-semibold mb-4 text-white">
              Perusahaan
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.neuronworks.co.id/"
                  className="text-gray-300 hover:text-perisalah-purple transition-colors"
                >
                  Tentang kami
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/628112127696"
                  className="text-gray-300 hover:text-perisalah-purple transition-colors"
                >
                  Customer Care
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/6285144919610"
                  className="text-gray-300 hover:text-perisalah-purple transition-colors"
                >
                  Support Aplikasi
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`${
              isVisible ? "animate-fade-in-up delay-300" : "opacity-0"
            }`}
          >
            <div className="mt-6 p-4 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm">
              <h5 className="font-medium text-white mb-2">Kantor</h5>
              <address className="text-gray-300 not-italic">
                PT Neuronworks Indonesia
                <br />
                Komp. Buah Batu Regency A2 No.9 - 10
                <br />
                Kel. Kujangsari, Bandung 40287
                <br />
                Jawa Barat, Indonesia
              </address>
              <p className="mt-2 text-gray-300">
                Email:{" "}
                <a
                  href="mailto:marketing@neuronworks.co.id"
                  className="hover:underline"
                >
                  marketing@neuronworks.co.id
                </a>
              </p>
            </div>
          </div>
        </div>

        <div
          className={`mt-16 pt-6 border-t border-white/10 ${
            isVisible ? "animate-fade-in-up delay-400" : "opacity-0"
          }`}
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="text-gray-400 text-sm text-left w-full md:w-auto">
              © {currentYear} PT Neuronworks Indonesia. Hak cipta dilindungi.
            </div>
            <div className="flex flex-wrap justify-center md:justify-end gap-6 mt-4 md:mt-0 w-full md:w-auto">
              <button
                onClick={() => setShowPrivacyPolicy(true)}
                className="text-gray-400 hover:text-perisalah-blue text-sm transition-colors"
              >
                Kebijakan Privasi
              </button>
              <button
                onClick={() => setShowTerms(true)}
                className="text-gray-400 hover:text-perisalah-blue text-sm transition-colors"
              >
                Syarat Layanan
              </button>
              <button
                onClick={() => setShowSecurity(true)}
                className="text-gray-400 hover:text-perisalah-blue text-sm transition-colors"
              >
                Keamanan
              </button>
              <button
                onClick={() => setShowAccessibility(true)}
                className="text-gray-400 hover:text-perisalah-blue text-sm transition-colors"
              >
                Aksesibilitas
              </button>
            </div>
          </div>
        </div>
        <InfoModal
          title="Kebijakan Privasi"
          content={privacyPolicyContent}
          isOpen={showPrivacyPolicy}
          onClose={() => setShowPrivacyPolicy(false)}
        />
        <InfoModal
          title="Syarat Layanan"
          content={termsContent}
          isOpen={showTerms}
          onClose={() => setShowTerms(false)}
        />
        <InfoModal
          title="Keamanan"
          content={securityContent}
          isOpen={showSecurity}
          onClose={() => setShowSecurity(false)}
        />
        <InfoModal
          title="Aksesibilitas"
          content={accessibilityContent}
          isOpen={showAccessibility}
          onClose={() => setShowAccessibility(false)}
        />
      </div>
    </footer>
  );
};

export default Footer;
